<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="50vw" >
    <v-btn color="secondary" dark slot="activator">
      <v-icon small>$vuetify.icons.rms_create</v-icon>
      {{ $t("rms.button.create") }}
    </v-btn>
    <v-card>
      <v-card-title class="px-4">
        <div class="title">{{ $t("screener.save.form.title") }}</div>
        <v-spacer></v-spacer>
        <v-btn
          class="mx-0 px-0"
          small
          dark
          icon
          color="grey"
          @click.stop="reset()"
        >
          <v-icon small>$vuetify.icons.rms_close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="max-height: 80vh">
        <v-stepper v-if="!is_vod_event" class="elevation-0" v-model="currentStep">
            <v-stepper-header
              flat
              class="elevation-0 px-0"
            >
              <v-stepper-step
                step="1"
                :complete="currentStep > 1"
                class="px-3"
                >{{$t('screener.create.step.select_event_type.title')}}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step
                step="2"
                :complete="currentStep > 2"
                class="px-3"
              >{{$t('screener.create.step.select_film.title')}}</v-stepper-step>
               <v-divider></v-divider>
              <v-stepper-step
                step="3"
                :complete="currentStep > 3"
                class="px-3"
              >{{$t('screener.create.step.basic_detail.title')}}</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items class="pa-3">
              <v-stepper-content step="1" class="pa-0">
                <AskEventType
                :venues="venues.data"
                :event_type.sync="screener.event_type"
                :physical_venue_id.sync="screener.physical_venue_id"
                @onCancel="reset"
                @onContinue="goToStep">
                </AskEventType>
              </v-stepper-content>
               <v-stepper-content step="2" class="pa-0">
                <AskFilm
                :films="films"
                :film_ids.sync="screener.film_ids"
                ></AskFilm>
                <div v-if="!films.length" class="py-1 subheading error--text">
                  {{$t('screener.create.step.select_film.warning')}}
                </div>
                <v-layout row wrap class="mt-5">
                  <v-flex xs4>
                     <v-btn class="ml-0" color="grey" outline @click.prevent="goToStep(1)">
                       <v-icon small class="px-1">$vuetify.icons.screener_back</v-icon>
                       {{ $t("screener.btn.back") }}
                      </v-btn>
                  </v-flex>
                  <v-flex xs8 class="text-xs-right">
                      <v-btn class="ml-0" color="grey" outline @click.prevent="reset">{{
                      $t("rms.button.cancel")
                      }}</v-btn>
                      <v-btn class="mr-0" color="primary" :disabled="!screener.film_ids.length" outline @click.prevent="goToStep(3)">{{
                      $t("rms.button.continue")
                      }}</v-btn>
                  </v-flex>
                </v-layout>
              </v-stepper-content>
               <v-stepper-content step="3" class="pa-0">
                <AskBasicDetails
                :is_vod_event="is_vod_event"
                @update:title="updateTitle"
                :screening_starts_at.sync="screener.screening_starts_at"
                :screening_ends_at.sync="screener.screening_ends_at"
                :vod_availability.sync="screener.vod_availability"
                :loading="loading"
                @onBack="goToStep"
                @onCancel="reset"
                @onConfirm="create">
                </AskBasicDetails>
              </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <AskBasicDetails
        class="pa-2"
        v-else
        :is_vod_event="is_vod_event"
        @update:title="updateTitle"
        :screening_starts_at.sync="screener.screening_starts_at"
        :screening_ends_at.sync="screener.screening_ends_at"
        :vod_availability.sync="screener.vod_availability"
        :loading="loading"
        @onBack="goToStep"
        @onCancel="reset"
        @onConfirm="create">
        </AskBasicDetails>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import DEFINES from "@/defines";
import { mapState, mapGetters } from "vuex";
import { tzToUtc } from "@/helper";
import AskEventType from "@/components/screener/AskEventType";
import AskFilm from "@/components/screener/AskFilm";
import AskBasicDetails from "@/components/screener/AskBasicDetails";
import { mapFields } from "vuex-map-fields";

export default {
  name: "CreateScreener",
  props: {
    is_vod_event: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      screener: this.initiateDefaultScreener(),
      loading:false,
      currentStep: 1
    };
  },
  components:{
    AskEventType,
    AskFilm,
    AskBasicDetails
  },
  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected",
      timezone: "getSelectedCompanyTimezone",
    }),
     ...mapState({
      films: (state) => state.film.selection_list
    }),
    ...mapFields("venue", {
        venues: "list",
    }),
  },
  watch: {
    // update vod flag in case not udated automatically
    '$route': 'updateIsVodEvent'
  },
  created(){
    this.getFilms();
    this.getVenues();
  },
  methods: {
    async getVenues() {
        try {
            await this.$store.dispatch("venue/list");
        } catch (error) {
            this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: "error",
            });
        }
    },
    async getFilms() {
      try {
        await this.$store.dispatch("film/getSelectionList");
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    goToStep(step=1){
      this.currentStep = step;
    },
    getSeatLimitation() {
      // In case of VOD events limitation is null
      if(this.is_vod_event){
        return null;
      }

      return this.$store.state.company.company &&
        this.$store.state.company.company.is_screening_pricing_enterprise
        ? this.$store.state.company.company.max_allowed_seats
        : DEFINES.PREMIUM_SCREENING_MIN_SEATS;
    },
    getScreeningType() {
      return this.$store.state.company.company &&
        this.$store.state.company.company.is_screening_pricing_enterprise
        ? DEFINES.SCREENING_PLAN_TYPE.ENTERPRISE
        : DEFINES.SCREENING_PLAN_TYPE.FREE;
    },
    async create() {
      this.loading = true;
      try {
        var screener = Object.assign({}, this.screener);

        // convert company timezone to UTC
        screener.screening_starts_at = tzToUtc(
          screener.screening_starts_at,
          this.timezone
        );
        screener.screening_ends_at = tzToUtc(
          screener.screening_ends_at,
          this.timezone
        );
        var response = await this.$store.dispatch("screener/create", screener);
        await this.$store.dispatch("screener/list",{
          is_vod_event: this.is_vod_event,
        });
        this.$router.push({
          name: response.result.is_vod_event ?'vod.save' : 'screener.save',
         params: {
            company_id: this.selected_company_id,
            screener_id: response.result.id,
            default_tab: "details",
          },
          query: response.result.is_vod_event ?{isVodEvent: true} :null
        });
        this.$store.dispatch("app/showMessage", {
          message: "Event created successfully ",
          color: "success",
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }finally{
        this.loading = false;
      }
    },
    updateIsVodEvent() {
      this.screener.is_vod_event = this.$route.query && this.$route.query.isVodEvent ? true : false;
    },
    initiateDefaultScreener() {
      return {
        title: {
          'en' : '',
          'es' : '',
          'he' : '',
          'ru' : '',
          'it' : ''
        },
        venue: null,
        vod_availability: DEFINES.VOD_EVENT_DEFAULT_AVAILABILITY,
        is_vod_event: this.is_vod_event,
        screening_starts_at: null,
        screening_ends_at: null,
        screening_type: this.getScreeningType(),
        pricing_type: DEFINES.PREMIUM_SCREENING_PRICING_TYPE.NORMAL,
        limitation: this.getSeatLimitation(),
        event_type: DEFINES.SCREENER_TYPE.VIRTUAL,
        film_ids:[],
        physical_venue_id:null,
        qa_info: {
          title: null,
          message: null,
          zoom_link: null,
          meeting_id: null,
          password: null,
        },
      }
    },
    reset() {
      this.dialog = false;
      this.screener = this.initiateDefaultScreener();
      this.currentStep = 1;
    },
    updateTitle(newTitle) {
      this.screener.title = newTitle;
    },
  },
};
</script>
